import DecisionNodeBase from '~/models/journey/DecisionNodeBase'
import type { WaypointNode } from '~/models/journey/waypoints'
import type { Path } from '~/types/util'
import { WaypointResult } from '~/generated/api-clients-generated'

export default class ExitFlowNode extends DecisionNodeBase {
  getNext(): WaypointNode | Path | null {
    return this._destinations.get(WaypointResult.Next) ?? null
  }
}
